import React from "react";
import { FaShower } from "react-icons/fa";
import { MdGroup, MdOutlineBedroomParent } from "react-icons/md";
import { Link } from "react-router-dom";

const ListingOutOverlay = (props) => {
  const { e, handleFav, handleRemove, handleCompare } = props;
  return (
    <>
      <div className="bg-white p-4">
        <div className="geodir-category-img">
          <Link
            to={`/details/${e.id}`}
            className="geodir-category-img-wrap fl-wrap"
          >
            <img
              style={{
                width: "300px",
                height: "250px",
              }}
              src={e?.listing_images[0]?.image}
              alt=""
            />
          </Link>
          <div
            onClick={() => handleFav(e.id)}
            className={
              e?.is_favourite === 1
                ? "geodir-js-favorite_btn1"
                : "geodir-js-favorite_btn"
            }
          >
            <i style={{ fontSize: "20px" }} className="fal fa-heart" />
            <span>{e?.is_favourite === 1 ? "saved" : "unsaved"}</span>
          </div>
          <div className="absolute bottom-5 z-10 left-4">
            <h3 className="title-sin_map  font-bold text-xl">
              <Link to={`/details/${e.id}`} className="text-white">
                $ {e?.nightly}
              </Link>
            </h3>
          </div>
        </div>
        <div className="listing-rating-count-wrap">
          <div
            className="listing-rating card-popup-rainingvis"
            data-starrating2={5}
          />
          <h3 className="title-sin_map text-black text-left text-lg font-bold my-2">
            <Link to={`/details/${e.id}`} style={{ color: "black" }}>
              {e?.host?.first_name + " " + e?.address}
            </Link>
          </h3>
        </div>
        <div
          className="geodir-category-location"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Link
            to={`/details/${e.id}`}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MdOutlineBedroomParent size={20} color="black" />{" "}
            <p className="text-black">{e?.no_of_bedroom}</p>
          </Link>
          <Link
            to={`/details/${e.id}`}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <FaShower size={20} color="black" />
            <p className="text-black">{e?.no_of_bathroom}</p>
          </Link>
          <Link
            to={`/details/${e.id}`}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MdGroup size={20} color="black" />
            <p className="text-black">{e?.no_of_guest}</p>
          </Link>
          {e.is_compare === 0 ? (
            <div
              onClick={() => handleRemove(e.id, e.is_compare)}
              className="btn btn-secondary"
              style={{ padding: "6px 7px" }}
            >
              Remove
            </div>
          ) : (
            <div
              onClick={() => handleCompare(e.id, e.is_compare)}
              className="btn btn-secondary"
              style={{ padding: "6px 7px" }}
            >
              Compare
            </div>
          )}
        </div>
        <h3
          className="title-sin_map text-black text-left"
          style={{ fontSize: "18px" }}
        >
          <Link to={`/details/${e.id}`} style={{ color: "black" }}>
            {e?.dwelling}
          </Link>
        </h3>
      </div>
    </>
  );
};

export default ListingOutOverlay;
